import sanitizeHtml from 'sanitize-html';

export class Highlight {

  static highlight(value: string, searched: string) {
    const diffMatches = [];

    if (value !== null && value !== undefined) {
      value = String(value).replace(/\r?\n/g, ' ');
      value = sanitizeHtml(value, {
        allowedTags: [],
        allowedAttributes: []
      });

      if (searched && searched.trim()) {
        const escapes = /[.*+?^${}()|[\]\\]/g;
        const pattern = new RegExp(
          searched.trim()
            .split('')
            .map(x => x.replace(escapes, '\\$&'))
            .join('\\W?'),
          'gi'
        );

        (value.match(pattern) || []).forEach((x) => {
          if (!diffMatches.some(y => x === y)) {
            diffMatches.push(x);

            const p = new RegExp(
              x.split('').map(z => z.replace(escapes, '\\$&')).join(''),
              'g'
            );

            value = value.replace(p, `<mark class="search-mark">${x}</mark>`);
          }
        });
      }

      return value;
    } else {
      return '--';
    }
  }
}
